<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div class="col-md-12" style="margin-bottom: 7px !important">
    <a style="margin-right: 15px" v-if="user_profile.cadastro_tipo == 'pf'">
      <b>Nome:</b>
      {{ user_profile.nome_completo }}
    </a>
    <a style="margin-right: 15px" v-else>
      <b>Razão social:</b>
      {{ user_profile.pj_razao_social }}
    </a>
    <br />
    <b>Status do cadastro:&nbsp;</b>
    <strong style="text-transform: uppercase; #d7ac00" v-if="user_profile.user.status == 'pendente'">
      {{ user_profile.user.status }}
    </strong>
    <strong style="text-transform: uppercase; color: #007d41" v-else-if="user_profile.user.status == 'liberado'">
      {{ user_profile.user.status }}
    </strong>
    <strong style="text-transform: uppercase; color: red" v-else-if="user_profile.user.status == 'bloqueado'">{{ user_profile.user.status }}</strong>
    <strong style="text-transform: uppercase" v-else="user_profile.user.status == 'liberado'">{{ user_profile.user.status }}</strong>
  </div>

  <div class="col-md-12">
    <div class="card" style="background-color: rgb(219, 181, 10) !important" v-if="user_profile.pendencias.length">
      <div class="card-body p-2">
        <i class="fa-solid fa-circle-exclamation" style="margin-right: 2px"></i>
        <b>Possui pendências, verificar:</b>
        <br />
        <p v-for="(pendencia, index) in user_profile.pendencias" :key="pendencia">
          <span>Data: {{ formatDate(pendencia.created_at) }}</span>
          <br />
          <span v-html="pendencia.conteudo"></span>
        </p>
      </div>
    </div>
  </div>

  <div class="col-md-12">
    <div class="card card-primary">
      <div class="card-header">
        <h3 class="card-title" style="color: white">Envie seus documentos</h3>
      </div>

      <div class="card-body">
        <div style="line-height: 12px">
          <span v-html="texto_dinamico.texto"></span>
        </div>
        <!--
        <span style="color: red">EVITE O BLOQUEIO DO CADASTRO!</span>
        <br />
        <span style="color: red">Para liberação é necessário anexar todos os documentos solicitados em até 24h.</span>
        <br />
        <br />
        <div v-if="user_profile.cadastro_tipo == 'pf'">
          <span style="color: red">PESSOA FÍSICA:</span>
          <br />
          <span style="color: red">- RG e CPF ou CNH válida;</span>
          <br />
          <span style="color: red">- Comprovante de residência atualizado (últimos 03 meses);</span>
          <br />
          <span style="color: red">- Se casado: Certidão de Casamento ou de União Estável e RG e CPF ou CNH válida do cônjuge;</span>
          <br />
          <span style="color: red">- Se divorciado: Certidão de divórcio.</span>
          <br />
          <br />
        </div>

        <div v-if="user_profile.cadastro_tipo == 'pj'">
          <span style="color: red">PESSOA JURÍDICA:</span>
          <br />
          <span style="color: red">- Inscrição no CNPJ;</span>
          <br />
          <span style="color: red">- Contrato Social com última alteração;</span>
          <br />
          <span style="color: red">- RG e CPF ou CNH válida do representante legal.</span>
          <br />
        </div>
        
        <br />
        <br />
        -->

        <div class="row">
          <div class="col-6 col-sm-6 col-md-3">
            <label for="exampleInputFile">Tipo documento</label>
            <select class="custom-select rounded-0" id="documento" v-model="formData.documento">
              <option v-for="doc_tipo_usuario in aux_docs_tipo_usuario" :key="doc_tipo_usuario" :value="doc_tipo_usuario">
                {{ doc_tipo_usuario.tipodoc }}
              </option>
            </select>

            <span style="color: red" v-for="error in v$.documento.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>

          <!-- ARQUIVO -->
          <div class="col-sm-9">
            <div class="form-group">
              <label for="exampleInputFile">Arquivo</label>

              <div class="input-group mb-3">
                <input class="form-control" type="file" @change="onChange" />
                <div class="input-group-append">
                  <button type="submit" class="btn btn-primary" @click="sendFileS3()">Enviar</button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12"></div>
        </div>
      </div>

      <div class="card-body card-primary p-0">
        <div class="card-header">
          <h3 class="card-title" style="color: white">Documentos enviados</h3>
        </div>
        <div>
          <br />
          <user-dashboard
            :cont_enviados="cont_enviados"
            :cont_aguardando="cont_aguardando"
            :cont_rejeitados="cont_rejeitados"
            :cont_necessarios="cont_necessarios"
            :cont_aprovados="cont_aprovados"
          />
        </div>

        <table class="table table-hover">
          <thead>
            <tr>
              <th style="">Novo nome</th>
              <th style="">Tipo doc</th>
              <th style="">Status</th>
              <th style="">Validade</th>
              <th style="">Justificativa</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="document in user_documents" :key="document">
              <td data-label="Nome">{{ document.nome }}</td>

              <td data-label="Tipo documento">{{ document.tipodoc }}</td>

              <td data-label="Status" :style="getStyle(document.verificado)">
                {{ convertStatus(document.verificado) }}
              </td>

              <td data-label="Validade" v-if="document.expira_em" :style="getStyleData(document)">{{ formatDateOnly(document.expira_em) }}</td>
              <td data-label="Validade" v-else>-</td>

              <td data-label="Justificativa">{{ document.justificativa }}</td>

              <td data-label="Visualizar">
                <button
                  data-toggle="modal"
                  data-target="#visualizar-modal"
                  @click="selecionarDocumento(document)"
                  type="button"
                  class="btn btn-primary btn-sm"
                >
                  Visualizar
                  <i class="fa fa-search"></i>
                </button>
                <button
                  style="margin-left: 5px"
                  @click="confirmarDelete(document)"
                  type="button"
                  class="btn btn-danger btn-sm"
                  v-if="document.verificado != 1"
                >
                  Deletar
                  <i class="fa fa-trash"></i>
                </button>
              </td>

              <!--
              <td>
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div id="meu_menu" class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>

                  <a href="#" class="dropdown-item" @click="confirmarDelete(document)" v-if="document.verificado != 1">
                    <i class="fa-solid fa-trash"></i>
                    &nbsp;&nbsp; Deletar
                  </a>

                  <div class="dropdown-divider"></div>
                  <a href="#" data-toggle="modal" data-target="#visualizar-modal" @click="selecionarDocumento(document)" class="dropdown-item">
                    <i class="fa-solid fa-search"></i>
                    &nbsp;&nbsp; Visualizar
                  </a>
                </div>
              </td>
              -->
            </tr>
          </tbody>
        </table>
      </div>

      <!-- MODAL VISUALIZAR DOCUMENTO -->
      <div
        class="modal fade"
        id="visualizar-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
        style="margin-top: 30px"
      >
        <form @submit.prevent v-if="documento_selecionado">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4>Documento enviado</h4>
                <br />
                <div class="card card-primary">
                  <div class="card-body">
                    <div class="tab-content p-0">
                      <object
                        v-if="file_type == 'pdf' || file_type == 'PDF'"
                        :data="getDocumentPath(documento_selecionado)"
                        type="application/pdf"
                        width="100%"
                        height="600px"
                      ></object>

                      <img v-else :src="getDocumentPath(documento_selecionado)" width="100%" />
                    </div>
                  </div>
                  <!-- /.card-body -->

                  <div class="card-footer">
                    <button data-toggle="modal" id="cancelar" data-target="#visualizar-modal" class="btn btn-danger">Fechar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

import useVueLidate from "@vuelidate/core";
import { email, sameAs, helpers } from "@vuelidate/validators";
import { required } from "../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  props: [
    "docs_tipo_usuario",
    "user_documents",
    "user_profile",
    "texto_dinamico",
    "cont_enviados",
    "cont_aguardando",
    "cont_rejeitados",
    "cont_necessarios",
    "cont_aprovados",
  ],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading },

  setup() {
    const formData = reactive({
      documento: "",
    });

    const rules = computed(() => {
      return {
        documento: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  data() {
    return {
      isLoading: false,
      doc_tipo_usuario_selecionado: "",
      upload_files: "",
      aux_docs_tipo_usuario: [],
      documento_selecionado: "",
      file_type: "",
    };
  },

  mounted() {
    console.log("Texto");
    console.log(this.user_profile);

    this.aux_docs_tipo_usuario = this.docs_tipo_usuario;

    /*
        //REMOVENDO JÁ ENVIADOS
        for (let i = 0; i < this.docs_tipo_usuario.length; i++) {
            let indice = this.findTipodoc(this.docs_tipo_usuario[i].tipodoc);

            console.log(indice);

            if (indice < 0) {
                this.aux_docs_tipo_usuario.push(this.docs_tipo_usuario[i]);
            }
        }
        */
  },

  methods: {
    getStyleData(documento) {
      let data = this.formatDate(documento.expira_em);

      if (data != "Invalid date") {
        let vencido = new Date() >= new Date(documento.expira_em);

        if (vencido) {
          return "color: red";
        }
      }
    },

    selecionarDocumento(document) {
      this.documento_selecionado = document;

      let arr = this.documento_selecionado.arquivo.split(".");
      this.file_type = arr[arr.length - 1];

      console.log("File = " + this.file_type);
      console.log(arr);
    },

    confirmarDelete(document) {
      let html =
        "Deseja <b style='font-size:20px'>Deletar </b> o documento<br/> <b style='font-size:25px'>" +
        document.nome +
        "</b><br/> para enviar outro em seu lugar?";

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim!",
        })
        .then((result) => {
          if (result.value) {
            this.deletar(document);
          }
        });
    },

    deletar(document) {
      this.isLoading = true;

      let data = {
        id: document.id,
      };

      console.log("DELETANDO");
      console.log(data);

      axios
        .post(`/user/document/delete`, data)
        .then((response) => {
          if (response.data.success) {
            let data = {
              path: this.getOnlyDocumentPath(document),
            };

            console.log("DELETANDO S3");
            console.log(data);

            axios
              .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/delete-file`, data)
              .then((response) => {
                this.isLoading = false;

                this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Arquivo deletado", "/user");
              })
              .catch((error) => {
                console.log(error);
                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error);
              });
          } else {
            this.isLoading = false;

            this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/user");
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", "Email já cadastrado!");
          this.isLoading = false;
        });
    },

    findTipodoc(tipodoc) {
      let indice = this.user_documents.findIndex((element) => element["tipodoc"] == tipodoc);

      return indice;
    },

    convertStatus(status) {
      if (status == 1) {
        return "Aprovado";
      } else if (status == 2) {
        return "Rejeitado";
      } else {
        return "Aguardando";
      }
    },

    getStyle(status) {
      if (status == 1) {
        return "color: #007d41";
      } else if (status == 2) {
        return "color: red";
      } else {
        ("");
      }
    },

    onChange(e) {
      this.upload_files = e.target.files[0];
    },

    show(doc_tipo_usuario) {
      this.doc_tipo_usuario_selecionado = doc_tipo_usuario;
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    getDocumentPath(document) {
      if (document && document.path) {
        if (document.path.includes("rochaleiloes3")) {
          return process.env.MIX_VUE_APP_S3_BASE3_URL + document.path + "/" + document.arquivo;
        } else if (document.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + document.path + "/" + document.arquivo;
        } else if (document.path.includes("rochaleiloes") || document.arquivo.includes("banner_")) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + document.path + "/" + document.arquivo;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + document.path + "/" + document.arquivo;
        }
      }
    },

    getOnlyDocumentPath(document) {
      console.log("Doc");
      console.log(document);

      if (document) {
        if (document.path.includes("rochaleiloes3")) {
          return document.path + "/" + document.arquivo;
        } else if (document.path.includes("rochaleiloes2")) {
          return document.path + "/" + document.arquivo;
        } else if (document.path.includes("rochaleiloes") || document.arquivo.includes("banner_")) {
          return document.path + "/" + document.arquivo;
        } else {
          return document.path + "/" + document.arquivo;
        }
      }
    },

    async sendFileS3() {
      const result = await this.v$.$validate();

      if (result) {
        if (this.upload_files) {
          this.isLoading = true;

          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("id", "1");
            formData.append("path", "rochaleiloes2/usuarios/" + this.user_profile.user_id + "/");
            formData.append("file", this.upload_files);

            axios
              .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/upload`, formData)
              .then((response) => {
                console.log("ENVIANDO PARA O BANCO\n");

                this.uploadFD(response.data.key);
              })
              .catch((error) => {
                console.log(error);

                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error.response.data.error);
                console.log(error);
                reject();
              });
          });
        } else {
          this.showErrorMessageWithButton("Ops...", "Envie um arquivo válido!");
          this.cep_valido = false;
        }
      }
    },

    async uploadFD(file) {
      try {
        this.isLoading = true;

        let fileName = file.split("/");
        let fd = new FormData();
        fd.append("cpf_formatado", this.user_profile.cpf.replace(/[^Z0-9]/g, ""));

        if (this.user_profile.cadastro_tipo == "pj") {
          fd.append("cnpj_formatado", this.user_profile.pj_cnpj.replace(/[^Z0-9]/g, ""));
        }

        fd.append("path", "rochaleiloes2/usuarios/" + this.user_profile.user_id);
        fd.append("file", fileName[fileName.length - 1]);
        fd.append("obrigatorio", this.formData.documento.obrigatorio);
        fd.append("tipodoc", this.formData.documento.tipodoc);

        console.log("ATUALIZANDO");
        console.log(fd);

        axios
          .post(`/user/document/upload`, fd)
          .then((response) => {
            this.isLoading = false;

            this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Documento enviado!", "/user");
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;

            this.showErrorMessageWithButton("Ops..", error);
          });
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },

    formatDateOnly(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
